import { Component, OnChanges, Input, ElementRef, ViewChild } from '@angular/core';
import { NWCMStatusMonthData, NWCMPointDef, NWCMPointData } from '../../shared/misc-classes';
import { DataService } from '../../shared/dataservice.service';
import { Router } from '@angular/router';

@Component({
  selector: 'nwcm-tree-compact',
  templateUrl: './nwcm-tree-compact.component.html',
  styleUrls: ['./nwcm-tree-compact.component.css']
})
export class NwcmTreeCompactComponent implements OnChanges {

  isLoading:boolean = false;
  isLoaded:boolean = false;
  isFailed:boolean = false;
  failMessage:string = '';

  widthFactor:number = 1.0;
  heightFactor:number = 1.0;
  refDevWidth:number = 1920;
  refDevHeight:number = 1080;

  @ViewChild('nwcmimg') imgElt:ElementRef;

  @Input() monthObj:Date = new Date();

  _pointArray:NWCMPointDef[] = [
   new NWCMPointDef("1",90,165,50,"0","FPY Testing %",""),
  new NWCMPointDef("2",273,235,50,"0","TPT",""),
  new NWCMPointDef("3",710,248,50,"0","Safety Stock",""),
  new NWCMPointDef("4",715,190,50,"0","OTD %",""),
  new NWCMPointDef("5",810,179,50,"0","ROTD %",""),
  new NWCMPointDef("6",928,205,50,"0","Ready & Waiting",""),
  new NWCMPointDef("7",967,250,50,"0","FG Conversion / Diversion",""),
  new NWCMPointDef("8",1250,290,50,"0","Inv Turns Spot",""),
  new NWCMPointDef("9",1250,320,50,"0","Inv Turns Avg",""),
  new NWCMPointDef("10",1862,368,50,"0","FPY Customer PO %",""),
  new NWCMPointDef("11",1810,420,50,"0","Customer PO to PO handover",""),
  new NWCMPointDef("12",1780,470,50,"0","FPY Sale Order %",""),
  new NWCMPointDef("13",1760,500,50,"0","PO receive to SO approval",""),
  new NWCMPointDef("14",1520,480,50,"0","TTPT",""),
  new NWCMPointDef("15",1855,638,50,"0","Advance payment collection",""),
  new NWCMPointDef("16",1855,700,50,"0","Non forecase receivables",""),
  new NWCMPointDef("17",1100,450,50,"0","DIH",""),
  new NWCMPointDef("18",710,638,50,"0","Inventories",""),
  new NWCMPointDef("19",290,548,50,"0","Stock Obsolecence",""),
  new NWCMPointDef("20",210,485,50,"0","Block Stock",""),
  new NWCMPointDef("21",130,558,50,"0","No. of Stock-outs",""),
  new NWCMPointDef("22",320,600,50,"0","Inventories spot %",""),
  new NWCMPointDef("23",240,780,50,"0","Supplier Lead Time",""),
  new NWCMPointDef("24",100,810,50,"0","Supplier OTD",""),
  new NWCMPointDef("25",447,933,45,"0","DPO-Spot",""),
  new NWCMPointDef("26",1384,809,50,"0","DSO-Spot",""),
  new NWCMPointDef("27",1540,808,50,"0","Overdue Spot %",""),
  new NWCMPointDef("28",1711,739,50,"0","Overdue receivables",""),
  new NWCMPointDef("29",1200,1010,60,"0","NWC Spot %","")
  ];
    
  constructor(public _dataService: DataService, private _router:Router) { }

  ngOnChanges() {
    //setTimeout(() => {
      this.loadMonthData();  
    //}, 10);
    
  }

  loadMonthData() {
    this.isLoading = true;
    this.isLoaded = false;
    this.isFailed = false;
    this.failMessage = '';
    this._dataService.loadNwcmTreeStatus(this.monthObj).subscribe((_nwcmMonthData: NWCMStatusMonthData) => {
      
      this._pointArray.forEach((_tmpPointDef:NWCMPointDef)=>{
        _tmpPointDef.Status = "0";
      });
       if (_nwcmMonthData != null) {
        _nwcmMonthData.Points.forEach((_tmpNwcmPoint:NWCMPointData) => {
          this._pointArray.forEach((_tmpPointDef:NWCMPointDef)=>{
            if(_tmpNwcmPoint.KPIId == _tmpPointDef.PointId){
              _tmpPointDef.Status = _tmpNwcmPoint.KPIStatus;
            }
          });
        });
       }
      this.isLoaded = true;
      this.isLoading = false;
      this.isFailed = false;
    });
  }
  imageLoaded(evnt){
    this.redrawPoints();
    //console.log(this.imgElt.nativeElement.offsetWidth);
  }
  imageResized(evnt){
    this.redrawPoints();
    //console.log(this.imgElt.nativeElement.offsetWidth);
  }

  getNWCMPointLeft(_tmpPoint:NWCMPointDef):string{
    return _tmpPoint.getLeft(this.widthFactor);
  }

  getNWCMPointWidth(_tmpPoint:NWCMPointDef):number{
    return _tmpPoint.getWidth(this.widthFactor);
  }

  getNWCMPointTop(_tmpPoint:NWCMPointDef):string{
    return _tmpPoint.getTop(this.heightFactor);
  }

  public getPointStatusSrc(_tmpStatus):string{
    switch(_tmpStatus){
      case "0":
        return "/assets/rad-grey.png";  
      case "1":
        return "/assets/rad-green.png";  
      case "2":
        return "/assets/rad-yellow.png";  
      case "3":
        return "/assets/rad-red.png";  
    }

    return "/assets/rad-grey.png";
  }

  private redrawPoints():void{
    var _tmpImgWidth:number = this.imgElt.nativeElement.offsetWidth;
    var _tmpImgHeight:number = this.imgElt.nativeElement.offsetHeight;
    this.widthFactor =  _tmpImgWidth / this.refDevWidth;
    this.heightFactor =  _tmpImgHeight / this.refDevHeight;
  }
  treeClicked():void{
    this._router.navigate(['/nwcm-tree'])
  }
}
